import {
  WEAVE_OR_KNIT_OPTIONS,
  OPACITY_OPTIONS,
  STRETCH_OPTIONS,
  GSM_WEIGHT_OPTIONS,
  FABRIC_VISUAL_TYPE_OPTIONS,
} from './fabricAnalysisOptions';
import { FABRIC_TEXTURES } from './fabricTextures';

function uniqueSorted(values) {
  return [...new Set(values.filter(Boolean))].sort((a, b) =>
    a.localeCompare(b, undefined, { sensitivity: 'base' })
  );
}

function fabricTextureNames() {
  const names = [];
  for (const cat of FABRIC_TEXTURES.fabricTextures || []) {
    for (const t of cat.types || []) {
      if (t?.name) names.push(t.name);
    }
  }
  return uniqueSorted([
    ...names,
    'Cotton',
    'Cotton blend',
    'Linen',
    'Linen blend',
    'Silk',
    'Wool',
    'Polyester',
    'Viscose',
    'Denim',
    'Jersey',
    'Other',
  ]);
}

export const GARMENT_FABRIC_ATTR_SELECT_OPTIONS = {
  fabricTypes: fabricTextureNames(),
  weaveOrKnit: uniqueSorted([
    ...WEAVE_OR_KNIT_OPTIONS,
    'woven',
    'knitted',
    'non-woven',
  ]),
  weight: uniqueSorted([
    'lightweight',
    'mid weight',
    'heavy weight',
    ...GSM_WEIGHT_OPTIONS,
    'Lightweight',
    'Mid weight',
    'Heavy weight',
  ]),
  stretch: uniqueSorted([
    ...STRETCH_OPTIONS,
    'low stretch',
    'minimal stretch',
    'moderate stretch',
    'high stretch',
    'non-stretch',
  ]),
  opacity: uniqueSorted([...OPACITY_OPTIONS, 'opaque', 'semi-transparent', 'sheer']),
  drape: uniqueSorted([
    'soft drape',
    'fluid drape',
    'moderate drape',
    'moderate structure',
    'structured drape',
    'crisp structure',
    'stiff',
  ]),
  texture: uniqueSorted([
    'smooth',
    'light texture',
    'textured',
    'ribbed',
    'slub',
    'matte',
    'sheen',
    'napped',
  ]),
  visualType: [...FABRIC_VISUAL_TYPE_OPTIONS],
  seasonSuitability: uniqueSorted([
    'spring',
    'summer',
    'fall',
    'winter',
    'trans-seasonal',
    'all season',
    'monsoon',
  ]),
};

export function mergeGarmentFabricSelectOptions(selectedValues, options = []) {
  const selected = Array.isArray(selectedValues) ? selectedValues : [];
  return uniqueSorted([
    ...selected.filter((v) => v && !options.includes(v)),
    ...options,
  ]);
}
